import React from "react";

const LogoComponent = () => {

	return (window.location.href.includes("backgroundcheck")) ? (<h3>BACKGROUND CHECK</h3>) : (
		<h3>DATA WORKER</h3>)
}

export default LogoComponent;